function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "30",
  cy: "26",
  r: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "29",
  height: "11",
  x: "5.5",
  y: "20.5",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 20.5v-5m7.5 10v1m-4-1v1m-4-1v1m-4-15a6.18 6.18 0 014.5-2 6.18 6.18 0 014.5 2m-7 2a3.63 3.63 0 015 0"
}));